import { ManageApis } from '../../APIS/ManageApis';
import { API_ENDPOINTS } from '../../constant';
import notify from '../../Utils/toastService';
import { handleApiError } from '../../Utils/Utils';

export const refreshCredit = async ({
  accountId,
  fetchCreditDetails,
  showAlert,
  setLoading,
}) => {
  try {
    if (!accountId) {
      notify.error('Account ID is required to refresh credits.');
    }
    setLoading(true);
    const url = `${API_ENDPOINTS.REFRESH_CREDIT}?accountId=${accountId}`;

    const response = await ManageApis('post', url, '', '');

    const { status_code, message } = response || {};
    const { status, message: responseMessage = '' } =
      response?.response_data || {};

    if (status_code === 200 && message === 'Success') {
      if (status === 'Success') {
        fetchCreditDetails();
      } else {
        handleApiError(status, responseMessage, status_code, showAlert);
      }
    } else {
      handleApiError(status, message, status_code, showAlert);
    }
  } catch (error) {
    console.error('Error refreshing credit:', error);
  } finally {
    setLoading(false);
  }
};
